import { EntityPropList } from '@/common/entities/entityProp/EntityPropList';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ValList } from '@/common/val/ValList';
import { ProgCotFilterList } from '@/md/entities/prog/ProgCotFilterList';
import { CtrtForm } from '../ctrt/CtrtForm';
import { PriceResList } from '../priceRes/PriceResList';
import { ProgPriceList } from '../progPrice/ProgPriceList';
import { TierResList } from '../tierRes/TierResList';
import { ProgBrandBonaFidePctList } from './ProgBrandBonaFidePctList';
import { ProgForm } from './ProgForm';

export const ProgDetail = () => {

  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <ProgForm /> },
    { id: 'ctrtTab', label: 'Contract', content: <CtrtForm entityId={entityObj.ctrtId} /> },
    { id: 'progPrice', label: 'Prices', content: <ProgPriceList progObj={entityObj} /> }
   

  ];

  if (entityObj.status === 'IMPL' && entityObj.tierBased) {
    tabSpecs.push({ id: 'tierRes', label: 'Tier Results', content: <TierResList progId={entityObj.id} /> });
  }



  if (entityObj.status === 'IMPL') {
    tabSpecs.push({ id: 'priceRes', label: (entityObj.progType === 'PRICE' ? 'Price Results' : 'Rebate Results'), content: <PriceResList progId={entityObj.id} /> });
  }

  tabSpecs.push(
    { id: 'bonaSplit', label: 'Bona Fide Brand Splits', content: <ProgBrandBonaFidePctList progObj={entityObj} /> },
    { id: 'entityProps', label: 'Properties', content: <EntityPropList parentEntity="PROG" parentEntityObj={entityObj} /> },
    { id: 'cotFilter', label: 'Class of Trade Filters', content: <ProgCotFilterList progObj={entityObj} /> },
    { id: 'val', label: 'Validations', content: <ValList parentEntity="PROG" parentEntityId={entityObj.id} /> },
  );

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}